exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "body {\r\n    padding-top: 70px; /* Required padding for .navbar-fixed-top. Remove if using .navbar-static-top. Change if height of navigation changes. */\r\n}\r\n\r\n.hero-spacer {\r\n    margin-top: 70px;\r\n}\r\n\r\n.hero-feature {\r\n    margin-bottom: 30px;\r\n}\r\n\r\nfooter {\r\n    margin: 50px 0;\r\n}\r\n\r\n.container-no-msg{\r\n    margin-top: 90px\r\n}\r\n.container-msg{\r\n    margin-top: 90px\r\n}\r\n\r\n.alert i {\r\n    color: red;\r\n    display: table-cell;\r\n}\r\n\r\n.alert-access{\r\n    display: inline-table;\r\n    width: 100%;\r\n}\r\n\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/ewerton.w.da.silva/Documents/Visual Studio 2017/Projects/SCL_Valia/SCL_Valia/src/app/paginas/home/home.component.css
// module id = ../../../../../src/app/paginas/home/home.component.css
// module chunks = 1